module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "interactive-fade",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    staticClass: "mobile-interactive"
  }, [_c('section', {
    attrs: {
      "id": "base-container",
      "data-sticky-container": ""
    }
  }, [_c('header', {
    staticClass: "sticky",
    attrs: {
      "data-sticky-wrap": ""
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [(_vm.loaded) ? _c('branding', {
    attrs: {
      "logo": _vm.company.logo,
      "altText": _vm.company.company_name,
      "link": _vm.company.url,
      "addClass": "mobile",
      "linkTarget": "_blank"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "main",
    class: {
      'not-entered': !_vm.hasEntered
    },
    attrs: {
      "data-sticky-container": ""
    }
  }, [_c('vue-tabs', {
    on: {
      "tab-change": _vm.handleTabChange
    },
    model: {
      value: (_vm.tabName),
      callback: function($$v) {
        _vm.tabName = $$v
      },
      expression: "tabName"
    }
  }, [_c('v-tab', {
    attrs: {
      "title": "Exposures"
    }
  }, [_c('mobile-content-exposures')], 1), _vm._v(" "), (_vm.hasCoverages) ? _c('v-tab', {
    attrs: {
      "title": _vm.addCoverageLabel
    }
  }, [_c('mobile-content-coverages')], 1) : _vm._e(), _vm._v(" "), _c('v-tab', {
    attrs: {
      "title": _vm.contactData.form_label
    }
  }, [_c('mobile-content-contact')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [(!_vm.hasEntered) ? _c('section', {
    class: {
      'active': !_vm.hasEntered
    },
    attrs: {
      "data-type": "landing"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('mobile-landing')], 1)]) : _vm._e(), _vm._v(" "), _c('section', {
    attrs: {
      "data-type": "privacy"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('mobile-content-privacy')], 1)]), _vm._v(" "), _c('section', {
    attrs: {
      "data-type": "terms"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('mobile-content-terms')], 1)])])], 1), _vm._v(" "), _c('footer', [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "share-control"
  }, [_c('a', {
    attrs: {
      "title": "Share"
    },
    on: {
      "click": _vm.shareApp
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-MBR_share",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('share-controls'), _vm._v(" "), _c('hr')], 1), _vm._v(" "), (_vm.contact.show) ? _c('div', {
    staticClass: "contact-link"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contact.text)
    }
  }), _vm._v(" "), _c('br'), _c('a', {
    style: ({
      color: _vm.cssPropColor('$color-primary')
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.contact.link.label)
    },
    on: {
      "click": function($event) {
        _vm.changeTab(_vm.contactData.form_label)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.disclaimerActive) ? _c('div', {
    staticClass: "disclaimer",
    domProps: {
      "innerHTML": _vm._s(_vm.disclaimer)
    }
  }) : _vm._e(), _vm._v(" "), _c('nav', {
    staticClass: "legal"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "title": "Privacy Policy"
    },
    on: {
      "click": function($event) {
        _vm.showPanel('privacy')
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Privacy Policy")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "title": "Terms and Conditions"
    },
    on: {
      "click": function($event) {
        _vm.showPanel('terms');
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Terms and Conditions")])])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cc4e2f8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileInteractive.vue
// module id = 444
// module chunks = 1